import BodyPage from './BodyPage';

export default BodyPage;
